// extracted by css-extract-rspack-plugin
export default {"root":"src-components-AnnotationStylePicker-module__root-Uy4A_t","field":"src-components-AnnotationStylePicker-module__field-nCXmKQ","label":"src-components-AnnotationStylePicker-module__label-p5CF9F","colorInput":"src-components-AnnotationStylePicker-module__colorInput-uG1HCI","numberInput":"src-components-AnnotationStylePicker-module__numberInput-ECX5kW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-AnnotationStylePicker-module__root-Uy4A_t\",\"field\":\"src-components-AnnotationStylePicker-module__field-nCXmKQ\",\"label\":\"src-components-AnnotationStylePicker-module__label-p5CF9F\",\"colorInput\":\"src-components-AnnotationStylePicker-module__colorInput-uG1HCI\",\"numberInput\":\"src-components-AnnotationStylePicker-module__numberInput-ECX5kW\"}";
        // 1793732228961
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  